import React from 'react'
import SendMailSettingPassword from 'src/containers/Auth/SendMailSettingPassword'

const SendMailSettingPasswordPage: React.FC = () => {
  return <SendMailSettingPassword />
}

export const PATH = '/pwd/setting' as const
export default SendMailSettingPasswordPage
